const FRAME_TOP_BAND_FRACTION = 0.08
const FRAME_BOTTOM_BAND_FRACTION = 0.18

export const loadImage = (url) => new Promise((resolve, reject) => {
  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.onload = () => resolve(img)
  img.onerror = reject
  img.src = url
})

export const drawImageAndFrame = (photographImg, frameImg, shrinkPercent, onError) => {
  const canvas = document.createElement('canvas')
  canvas.width = photographImg.width
  canvas.height = photographImg.height
  const ctx = canvas.getContext('2d')

  const parsedShrink = parseFloat(shrinkPercent)
  const shrinkFraction = isNaN(parsedShrink) ? 0 : Math.max(0, Math.min(99, parsedShrink)) / 100
  const photoScale = 1 - shrinkFraction
  const photoDestW = photographImg.width * photoScale
  const photoDestH = photographImg.height * photoScale
  const photoDestX = (photographImg.width - photoDestW) / 2
  const photoDestY = (photographImg.height - photoDestH) / 2

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, photographImg.width, photographImg.height)
  ctx.drawImage(photographImg, photoDestX, photoDestY, photoDestW, photoDestH)

  const widthScale = photographImg.width / frameImg.width

  const topBandSrcH = frameImg.height * FRAME_TOP_BAND_FRACTION
  const bottomBandSrcH = frameImg.height * FRAME_BOTTOM_BAND_FRACTION
  const middleBandSrcY = topBandSrcH
  const middleBandSrcH = frameImg.height - topBandSrcH - bottomBandSrcH

  const topBandDestH = topBandSrcH * widthScale
  const bottomBandDestH = bottomBandSrcH * widthScale
  const middleBandDestY = topBandDestH
  const middleBandDestH = photographImg.height - topBandDestH - bottomBandDestH

  if (middleBandDestH <= 0) {
    return onError
  }

  ctx.drawImage(
    frameImg,
    0, 0, frameImg.width, topBandSrcH,
    0, 0, photographImg.width, topBandDestH
  )

  ctx.drawImage(
    frameImg,
    0, middleBandSrcY, frameImg.width, middleBandSrcH,
    0, middleBandDestY, photographImg.width, middleBandDestH
  )

  ctx.drawImage(
    frameImg,
    0, frameImg.height - bottomBandSrcH, frameImg.width, bottomBandSrcH,
    0, photographImg.height - bottomBandDestH, photographImg.width, bottomBandDestH
  )

  return canvas.toDataURL('image/jpeg', 0.92)
}
